// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Char = require("bs-platform/lib/js/char.js");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Bytes = require("bs-platform/lib/js/bytes.js");
var Curry = require("bs-platform/lib/js/curry.js");
var $$Buffer = require("bs-platform/lib/js/buffer.js");
var CCChar = require("./CCChar.bs.js");
var Format = require("bs-platform/lib/js/format.js");
var $$String = require("bs-platform/lib/js/string.js");
var Hashtbl = require("bs-platform/lib/js/hashtbl.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_bytes = require("bs-platform/lib/js/caml_bytes.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Caml_string = require("bs-platform/lib/js/caml_string.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

function equal(a, b) {
  return a === b;
}

var hash = Hashtbl.hash;

function length(prim) {
  return prim.length;
}

function is_empty(s) {
  return s === "";
}

function rev(s) {
  var n = s.length;
  return $$String.init(n, (function (i) {
                return Caml_string.get(s, (n - i | 0) - 1 | 0);
              }));
}

function _to_list(s, _acc, _i, _len) {
  while(true) {
    var len = _len;
    var i = _i;
    var acc = _acc;
    if (len === 0) {
      return List.rev(acc);
    } else {
      _len = len - 1 | 0;
      _i = i + 1 | 0;
      _acc = /* :: */[
        Caml_string.get(s, i),
        acc
      ];
      continue ;
    }
  };
}

function is_sub(sub, i, s, j, sub_len) {
  if ((i + sub_len | 0) > sub.length) {
    Pervasives.invalid_arg("CCString.is_sub");
  }
  var sub$1 = sub;
  var i$1 = i;
  var s$1 = s;
  var j$1 = j;
  var len = sub_len;
  if ((j$1 + len | 0) <= s$1.length) {
    var _k = 0;
    while(true) {
      var k = _k;
      if (k === len) {
        return true;
      } else if (CCChar.equal(Caml_string.get(sub$1, i$1 + k | 0), Caml_string.get(s$1, j$1 + k | 0))) {
        _k = k + 1 | 0;
        continue ;
      } else {
        return false;
      }
    };
  } else {
    return false;
  }
}

function get_(dir) {
  if (dir) {
    return (function (s, i) {
        return Caml_string.get(s, (s.length - i | 0) - 1 | 0);
      });
  } else {
    return Caml_string.get;
  }
}

function kmp_compile_(dir, str) {
  var len = str.length;
  var get = get_(dir);
  if (len !== 0) {
    if (len !== 1) {
      var failure = Caml_array.caml_make_vect(len, 0);
      Caml_array.caml_array_set(failure, 0, -1);
      var i = 2;
      var j = 0;
      while(i < len) {
        var match = j;
        if (CCChar.equal(Curry._2(get, str, i - 1 | 0), Curry._2(get, str, j))) {
          j = j + 1 | 0;
          Caml_array.caml_array_set(failure, i, j);
          i = i + 1 | 0;
        } else if (match !== 0) {
          if (j <= 0) {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  /* tuple */[
                    "CCString.ml",
                    163,
                    16
                  ]
                ];
          }
          j = Caml_array.caml_array_get(failure, j);
        } else {
          Caml_array.caml_array_set(failure, i, 0);
          i = i + 1 | 0;
        }
      };
      return {
              failure: failure,
              str: str
            };
    } else {
      return {
              failure: [-1],
              str: str
            };
    }
  } else {
    return {
            failure: [],
            str: str
          };
  }
}

function pattern_length(param) {
  if (param.tag) {
    return param[0].str.length;
  } else {
    return 1;
  }
}

function compile(sub) {
  if (sub.length === 1) {
    return /* P_char */Block.__(0, [Caml_string.get(sub, 0)]);
  } else {
    return /* P_KMP */Block.__(1, [kmp_compile_(/* Direct */0, sub)]);
  }
}

function rcompile(sub) {
  if (sub.length === 1) {
    return /* P_char */Block.__(0, [Caml_string.get(sub, 0)]);
  } else {
    return /* P_KMP */Block.__(1, [kmp_compile_(/* Reverse */1, sub)]);
  }
}

function find($staropt$star, pattern, s) {
  var start = $staropt$star !== undefined ? $staropt$star : 0;
  if (pattern.tag) {
    var pattern$1 = pattern[0];
    var s$1 = s;
    var idx = start;
    var len = s$1.length;
    var i = idx;
    var j = 0;
    var pat_len = pattern$1.str.length;
    while(j < pat_len && (i + j | 0) < len) {
      var c = Caml_string.get(s$1, i + j | 0);
      var expected = Caml_string.get(pattern$1.str, j);
      if (CCChar.equal(c, expected)) {
        j = j + 1 | 0;
      } else {
        var fail_offset = Caml_array.caml_array_get(pattern$1.failure, j);
        if (fail_offset >= 0) {
          if (fail_offset >= j) {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  /* tuple */[
                    "CCString.ml",
                    192,
                    10
                  ]
                ];
          }
          i = (i + j | 0) - fail_offset | 0;
          j = fail_offset;
        } else {
          j = 0;
          i = i + 1 | 0;
        }
      }
    };
    if (j === pat_len) {
      return i;
    } else {
      return -1;
    }
  } else {
    try {
      return $$String.index_from(s, start, pattern[0]);
    }
    catch (exn){
      if (exn === Caml_builtin_exceptions.not_found) {
        return -1;
      } else {
        throw exn;
      }
    }
  }
}

function rfind(start, pattern, s) {
  var start$1 = start !== undefined ? start : s.length - 1 | 0;
  if (pattern.tag) {
    var pattern$1 = pattern[0];
    var s$1 = s;
    var idx = start$1;
    var len = s$1.length;
    var i = (len - idx | 0) - 1 | 0;
    var j = 0;
    var pat_len = pattern$1.str.length;
    while(j < pat_len && (i + j | 0) < len) {
      var c = Caml_string.get(s$1, ((len - i | 0) - j | 0) - 1 | 0);
      var expected = Caml_string.get(pattern$1.str, (pattern$1.str.length - j | 0) - 1 | 0);
      if (CCChar.equal(c, expected)) {
        j = j + 1 | 0;
      } else {
        var fail_offset = Caml_array.caml_array_get(pattern$1.failure, j);
        if (fail_offset >= 0) {
          if (fail_offset >= j) {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  /* tuple */[
                    "CCString.ml",
                    227,
                    10
                  ]
                ];
          }
          i = (i + j | 0) - fail_offset | 0;
          j = fail_offset;
        } else {
          j = 0;
          i = i + 1 | 0;
        }
      }
    };
    if (j === pat_len) {
      return (len - i | 0) - pattern$1.str.length | 0;
    } else {
      return -1;
    }
  } else {
    try {
      return $$String.rindex_from(s, start$1, pattern[0]);
    }
    catch (exn){
      if (exn === Caml_builtin_exceptions.not_found) {
        return -1;
      } else {
        throw exn;
      }
    }
  }
}

function find$1($staropt$star, sub) {
  var start = $staropt$star !== undefined ? $staropt$star : 0;
  var pattern = compile(sub);
  return (function (s) {
      return find(start, pattern, s);
    });
}

function find_all($staropt$star, sub) {
  var start = $staropt$star !== undefined ? $staropt$star : 0;
  var pattern = compile(sub);
  return (function (s) {
      var i = {
        contents: start
      };
      return (function (param) {
          var res = find(i.contents, pattern, s);
          if (res === -1) {
            return ;
          } else {
            i.contents = res + 1 | 0;
            return res;
          }
        });
    });
}

function find_all_l(start, sub, s) {
  var _acc = /* [] */0;
  var g = find_all(start, sub)(s);
  while(true) {
    var acc = _acc;
    var match = Curry._1(g, /* () */0);
    if (match !== undefined) {
      _acc = /* :: */[
        Caml_option.valFromOption(match),
        acc
      ];
      continue ;
    } else {
      return List.rev(acc);
    }
  };
}

function mem(start, sub, s) {
  return find$1(start, sub)(s) >= 0;
}

function rfind$1(sub) {
  var pattern = rcompile(sub);
  return (function (s) {
      return rfind(s.length - 1 | 0, pattern, s);
    });
}

function replace_at_(pos, len, by, s) {
  var b = $$Buffer.create((s.length + by.length | 0) - len | 0);
  $$Buffer.add_substring(b, s, 0, pos);
  $$Buffer.add_string(b, by);
  $$Buffer.add_substring(b, s, pos + len | 0, (s.length - pos | 0) - len | 0);
  return $$Buffer.contents(b);
}

function replace($staropt$star, sub, by, s) {
  var which = $staropt$star !== undefined ? $staropt$star : /* All */3256577;
  if (sub === "") {
    Pervasives.invalid_arg("CCString.replace");
  }
  if (which !== 3256577) {
    if (which >= 847852583) {
      var i = find$1(0, sub)(s);
      if (i >= 0) {
        return replace_at_(i, sub.length, by, s);
      } else {
        return s;
      }
    } else {
      var i$1 = rfind$1(sub)(s);
      if (i$1 >= 0) {
        return replace_at_(i$1, sub.length, by, s);
      } else {
        return s;
      }
    }
  } else {
    var pattern = compile(sub);
    var b = $$Buffer.create(s.length);
    var start = 0;
    while(start < s.length) {
      var i$2 = find(start, pattern, s);
      if (i$2 >= 0) {
        $$Buffer.add_substring(b, s, start, i$2 - start | 0);
        $$Buffer.add_string(b, by);
        start = i$2 + sub.length | 0;
      } else {
        $$Buffer.add_substring(b, s, start, s.length - start | 0);
        start = s.length;
      }
    };
    return $$Buffer.contents(b);
  }
}

var no_drop = {
  first: false,
  last: false
};

function _split(by, s, state) {
  if (state) {
    var by$1 = by;
    var s$1 = s;
    var prev = state[0];
    var j = find(prev, by$1, s$1);
    if (j < 0) {
      return /* tuple */[
              /* SplitStop */0,
              prev,
              s$1.length - prev | 0
            ];
    } else {
      return /* tuple */[
              /* SplitAt */[j + pattern_length(by$1) | 0],
              prev,
              j - prev | 0
            ];
    }
  }
  
}

function _tuple3(x, y, z) {
  return /* tuple */[
          x,
          y,
          z
        ];
}

function _mkgen(drop, by, s, k) {
  var state = {
    contents: /* SplitAt */[0]
  };
  var by$1 = compile(by);
  var next = function (_param) {
    while(true) {
      var match = _split(by$1, s, state.contents);
      if (match !== undefined) {
        var match$1 = match;
        var i = match$1[1];
        var state$prime = match$1[0];
        var exit = 0;
        if (i !== 0 || match$1[2] !== 0 || !drop.first) {
          exit = 1;
        } else {
          state.contents = state$prime;
          _param = /* () */0;
          continue ;
        }
        if (exit === 1) {
          var len = match$1[2];
          if (len === 0 && drop.last && i === s.length) {
            return ;
          }
          state.contents = state$prime;
          return Caml_option.some(Curry._3(k, s, i, len));
        }
        
      } else {
        return ;
      }
    };
  };
  return next;
}

function gen($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return _mkgen(drop, by, s, _tuple3);
}

function gen_cpy($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return _mkgen(drop, by, s, $$String.sub);
}

function _mklist(drop, by, s, k) {
  var by$1 = compile(by);
  var _acc = /* [] */0;
  var _state = /* SplitAt */[0];
  while(true) {
    var state = _state;
    var acc = _acc;
    var match = _split(by$1, s, state);
    if (match !== undefined) {
      var match$1 = match;
      var i = match$1[1];
      var state$prime = match$1[0];
      var exit = 0;
      if (i !== 0 || match$1[2] !== 0 || !drop.first) {
        exit = 1;
      } else {
        _state = state$prime;
        continue ;
      }
      if (exit === 1) {
        var len = match$1[2];
        if (len === 0 && drop.last && i === s.length) {
          return List.rev(acc);
        }
        _state = state$prime;
        _acc = /* :: */[
          Curry._3(k, s, i, len),
          acc
        ];
        continue ;
      }
      
    } else {
      return List.rev(acc);
    }
  };
}

function list_($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return _mklist(drop, by, s, _tuple3);
}

function list_cpy($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return _mklist(drop, by, s, $$String.sub);
}

function _mkklist(drop, by, s, k) {
  var by$1 = compile(by);
  var make = function (_state, _param) {
    while(true) {
      var state = _state;
      var match = _split(by$1, s, state);
      if (match !== undefined) {
        var match$1 = match;
        var i = match$1[1];
        var state$prime = match$1[0];
        var exit = 0;
        if (i !== 0 || match$1[2] !== 0 || !drop.first) {
          exit = 1;
        } else {
          _param = /* () */0;
          _state = state$prime;
          continue ;
        }
        if (exit === 1) {
          var len = match$1[2];
          if (len === 0 && drop.last && i === s.length) {
            return /* Nil */3902385;
          }
          return /* `Cons */[
                  748545553,
                  /* tuple */[
                    Curry._3(k, s, i, len),
                    (function(state$prime){
                    return function (param) {
                      return make(state$prime, param);
                    }
                    }(state$prime))
                  ]
                ];
        }
        
      } else {
        return /* Nil */3902385;
      }
    };
  };
  var partial_arg = /* SplitAt */[0];
  return (function (param) {
      return make(partial_arg, param);
    });
}

function klist($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return _mkklist(drop, by, s, _tuple3);
}

function klist_cpy($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return _mkklist(drop, by, s, $$String.sub);
}

function _mkseq(drop, by, s, f, k) {
  var by$1 = compile(by);
  var _state = /* SplitAt */[0];
  while(true) {
    var state = _state;
    var match = _split(by$1, s, state);
    if (match !== undefined) {
      var match$1 = match;
      var i = match$1[1];
      var state$prime = match$1[0];
      var exit = 0;
      if (i !== 0 || match$1[2] !== 0 || !drop.first) {
        exit = 1;
      } else {
        _state = state$prime;
        continue ;
      }
      if (exit === 1) {
        var len = match$1[2];
        if (len === 0 && drop.last && i === s.length) {
          return /* () */0;
        }
        Curry._1(k, Curry._3(f, s, i, len));
        _state = state$prime;
        continue ;
      }
      
    } else {
      return /* () */0;
    }
  };
}

function seq($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return (function (param) {
      return _mkseq(drop, by, s, _tuple3, param);
    });
}

function seq_cpy($staropt$star, by, s) {
  var drop = $staropt$star !== undefined ? $staropt$star : no_drop;
  return (function (param) {
      return _mkseq(drop, by, s, $$String.sub, param);
    });
}

function left_exn(by, s) {
  var i = find$1(undefined, by)(s);
  if (i === -1) {
    throw Caml_builtin_exceptions.not_found;
  }
  var right = i + by.length | 0;
  return /* tuple */[
          $$String.sub(s, 0, i),
          $$String.sub(s, right, s.length - right | 0)
        ];
}

function left(by, s) {
  try {
    return left_exn(by, s);
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return ;
    } else {
      throw exn;
    }
  }
}

function right_exn(by, s) {
  var i = rfind$1(by)(s);
  if (i === -1) {
    throw Caml_builtin_exceptions.not_found;
  }
  var right = i + by.length | 0;
  return /* tuple */[
          $$String.sub(s, 0, i),
          $$String.sub(s, right, s.length - right | 0)
        ];
}

function right(by, s) {
  try {
    return right_exn(by, s);
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return ;
    } else {
      throw exn;
    }
  }
}

function split_on_char(c, s) {
  return list_cpy(no_drop, $$String.make(1, c), s);
}

function split(by, s) {
  return list_cpy(undefined, by, s);
}

function compare_versions(a, b) {
  var of_int = function (s) {
    try {
      return Caml_format.caml_int_of_string(s);
    }
    catch (exn){
      return ;
    }
  };
  var a$1 = gen_cpy(undefined, ".", a);
  var b$1 = gen_cpy(undefined, ".", b);
  while(true) {
    var match = Curry._1(a$1, /* () */0);
    var match$1 = Curry._1(b$1, /* () */0);
    if (match !== undefined) {
      if (match$1 !== undefined) {
        var y = match$1;
        var x = match;
        var match$2 = of_int(x);
        var match$3 = of_int(y);
        if (match$2 !== undefined) {
          if (match$3 !== undefined) {
            var c = Caml_primitive.caml_int_compare(match$2, match$3);
            if (c !== 0) {
              return c;
            } else {
              continue ;
            }
          } else {
            return 1;
          }
        } else if (match$3 !== undefined) {
          return -1;
        } else {
          var c$1 = $$String.compare(x, y);
          if (c$1 !== 0) {
            return c$1;
          } else {
            continue ;
          }
        }
      } else {
        return 1;
      }
    } else if (match$1 !== undefined) {
      return -1;
    } else {
      return 0;
    }
  };
}

function compare_natural(a, b) {
  var chunks = function (s) {
    var i = {
      contents: 0
    };
    return (function (param) {
        if (i.contents === s.length) {
          return ;
        } else {
          var c = Caml_string.get(s, i.contents);
          if (c > 57 || c < 48) {
            i.contents = i.contents + 1 | 0;
            return /* NC_char */Block.__(0, [c]);
          } else {
            i.contents = i.contents + 1 | 0;
            var _n = c - /* "0" */48 | 0;
            while(true) {
              var n = _n;
              if (i.contents === s.length) {
                return /* NC_int */Block.__(1, [n]);
              } else {
                var c$1 = Caml_string.get(s, i.contents);
                if (c$1 > 57 || c$1 < 48) {
                  return /* NC_int */Block.__(1, [n]);
                } else {
                  i.contents = i.contents + 1 | 0;
                  _n = (Caml_int32.imul(10, n) + c$1 | 0) - /* "0" */48 | 0;
                  continue ;
                }
              }
            };
          }
        }
      });
  };
  var a$1 = chunks(a);
  var b$1 = chunks(b);
  while(true) {
    var match = Curry._1(a$1, /* () */0);
    var match$1 = Curry._1(b$1, /* () */0);
    if (match !== undefined) {
      if (match$1 !== undefined) {
        var y = match$1;
        var x = match;
        if (x.tag) {
          if (y.tag) {
            var c = Caml_primitive.caml_int_compare(x[0], y[0]);
            if (c !== 0) {
              return c;
            } else {
              continue ;
            }
          } else {
            return 1;
          }
        } else if (y.tag) {
          return -1;
        } else {
          var c$1 = Char.compare(x[0], y[0]);
          if (c$1 !== 0) {
            return c$1;
          } else {
            continue ;
          }
        }
      } else {
        return 1;
      }
    } else if (match$1 !== undefined) {
      return -1;
    } else {
      return 0;
    }
  };
}

function edit_distance(s1, s2) {
  if (s1.length === 0) {
    return s2.length;
  } else if (s2.length === 0) {
    return s1.length;
  } else if (s1 === s2) {
    return 0;
  } else {
    var v0 = Caml_array.caml_make_vect(s2.length + 1 | 0, 0);
    var v1 = Caml_array.caml_make_vect(s2.length + 1 | 0, 0);
    for(var i = 0 ,i_finish = s2.length; i <= i_finish; ++i){
      Caml_array.caml_array_set(v0, i, i);
    }
    for(var i$1 = 0 ,i_finish$1 = s1.length - 1 | 0; i$1 <= i_finish$1; ++i$1){
      Caml_array.caml_array_set(v1, 0, i$1 + 1 | 0);
      for(var j = 0 ,j_finish = s2.length - 1 | 0; j <= j_finish; ++j){
        var cost = Char.compare(Caml_string.get(s1, i$1), Caml_string.get(s2, j)) === 0 ? 0 : 1;
        Caml_array.caml_array_set(v1, j + 1 | 0, Caml_primitive.caml_int_min(Caml_array.caml_array_get(v1, j) + 1 | 0, Caml_primitive.caml_int_min(Caml_array.caml_array_get(v0, j + 1 | 0) + 1 | 0, Caml_array.caml_array_get(v0, j) + cost | 0)));
      }
      $$Array.blit(v1, 0, v0, 0, s2.length + 1 | 0);
    }
    return Caml_array.caml_array_get(v1, s2.length);
  }
}

function repeat(s, n) {
  if (n < 0) {
    throw [
          Caml_builtin_exceptions.assert_failure,
          /* tuple */[
            "CCString.ml",
            688,
            2
          ]
        ];
  }
  var len = s.length;
  if (len <= 0) {
    throw [
          Caml_builtin_exceptions.assert_failure,
          /* tuple */[
            "CCString.ml",
            690,
            2
          ]
        ];
  }
  return $$String.init(Caml_int32.imul(len, n), (function (i) {
                return Caml_string.get(s, Caml_int32.mod_(i, len));
              }));
}

function prefix(pre, s) {
  var len = pre.length;
  if (len > s.length) {
    return false;
  } else {
    var _i = 0;
    while(true) {
      var i = _i;
      if (i === len) {
        return true;
      } else if (s.charCodeAt(i) !== pre.charCodeAt(i)) {
        return false;
      } else {
        _i = i + 1 | 0;
        continue ;
      }
    };
  }
}

function suffix(suf, s) {
  var len = suf.length;
  if (len > s.length) {
    return false;
  } else {
    var off = s.length - len | 0;
    var _i = 0;
    while(true) {
      var i = _i;
      if (i === len) {
        return true;
      } else if (s.charCodeAt(off + i | 0) !== suf.charCodeAt(i)) {
        return false;
      } else {
        _i = i + 1 | 0;
        continue ;
      }
    };
  }
}

function take(n, s) {
  if (n < s.length) {
    return $$String.sub(s, 0, n);
  } else {
    return s;
  }
}

function drop(n, s) {
  if (n < s.length) {
    return $$String.sub(s, n, s.length - n | 0);
  } else {
    return "";
  }
}

function take_drop(n, s) {
  return /* tuple */[
          take(n, s),
          drop(n, s)
        ];
}

function chop_suffix(suf, s) {
  if (suffix(suf, s)) {
    return $$String.sub(s, 0, s.length - suf.length | 0);
  }
  
}

function chop_prefix(pre, s) {
  if (prefix(pre, s)) {
    return $$String.sub(s, pre.length, s.length - pre.length | 0);
  }
  
}

function fold(f, acc, s) {
  var f$1 = f;
  var _acc = acc;
  var s$1 = s;
  var _i = 0;
  while(true) {
    var i = _i;
    var acc$1 = _acc;
    if (i === s$1.length) {
      return acc$1;
    } else {
      _i = i + 1 | 0;
      _acc = Curry._2(f$1, acc$1, Caml_string.get(s$1, i));
      continue ;
    }
  };
}

function pad($staropt$star, $staropt$star$1, n, s) {
  var side = $staropt$star !== undefined ? $staropt$star : /* Left */847852583;
  var c = $staropt$star$1 !== undefined ? $staropt$star$1 : /* " " */32;
  var len_s = s.length;
  if (len_s >= n) {
    return s;
  } else {
    var pad_len = n - len_s | 0;
    if (side >= 847852583) {
      return $$String.init(n, (function (i) {
                    if (i < pad_len) {
                      return c;
                    } else {
                      return Caml_string.get(s, i - pad_len | 0);
                    }
                  }));
    } else {
      return $$String.init(n, (function (i) {
                    if (i < len_s) {
                      return Caml_string.get(s, i);
                    } else {
                      return c;
                    }
                  }));
    }
  }
}

function _to_gen(s, i0, len) {
  var i = {
    contents: i0
  };
  return (function (param) {
      if (i.contents === (i0 + len | 0)) {
        return ;
      } else {
        var c = s.charCodeAt(i.contents);
        i.contents = i.contents + 1 | 0;
        return c;
      }
    });
}

function to_gen(s) {
  return _to_gen(s, 0, s.length);
}

function of_char(c) {
  return $$String.make(1, c);
}

function of_gen(g) {
  var b = $$Buffer.create(32);
  var _param = /* () */0;
  while(true) {
    var match = Curry._1(g, /* () */0);
    if (match !== undefined) {
      $$Buffer.add_char(b, match);
      _param = /* () */0;
      continue ;
    } else {
      return $$Buffer.contents(b);
    }
  };
}

function to_seq(s, k) {
  return $$String.iter(k, s);
}

function of_seq(seq) {
  var b = $$Buffer.create(32);
  Curry._1(seq, (function (param) {
          return $$Buffer.add_char(b, param);
        }));
  return $$Buffer.contents(b);
}

function _to_klist(s, i, len, param) {
  if (len === 0) {
    return /* Nil */3902385;
  } else {
    var partial_arg = len - 1 | 0;
    var partial_arg$1 = i + 1 | 0;
    return /* `Cons */[
            748545553,
            /* tuple */[
              Caml_string.get(s, i),
              (function (param) {
                  return _to_klist(s, partial_arg$1, partial_arg, param);
                })
            ]
          ];
  }
}

function of_klist(l) {
  var b = $$Buffer.create(15);
  var _l = l;
  while(true) {
    var l$1 = _l;
    var match = Curry._1(l$1, /* () */0);
    if (typeof match === "number") {
      return $$Buffer.contents(b);
    } else {
      var match$1 = match[1];
      $$Buffer.add_char(b, match$1[0]);
      _l = match$1[1];
      continue ;
    }
  };
}

function to_klist(s) {
  var partial_arg = s.length;
  return (function (param) {
      return _to_klist(s, 0, partial_arg, param);
    });
}

function to_list(s) {
  return _to_list(s, /* [] */0, 0, s.length);
}

function of_list(l) {
  var buf = $$Buffer.create(List.length(l));
  List.iter((function (param) {
          return $$Buffer.add_char(buf, param);
        }), l);
  return $$Buffer.contents(buf);
}

function of_array(a) {
  return $$String.init(a.length, (function (i) {
                return Caml_array.caml_array_get(a, i);
              }));
}

function to_array(s) {
  return $$Array.init(s.length, (function (i) {
                return Caml_string.get(s, i);
              }));
}

function lines_gen(s) {
  return gen_cpy({
              first: false,
              last: true
            }, "\n", s);
}

function lines(s) {
  return list_cpy({
              first: false,
              last: true
            }, "\n", s);
}

function concat_gen_buf(sep, g) {
  var b = $$Buffer.create(256);
  var _first = true;
  var _param = /* () */0;
  while(true) {
    var first = _first;
    var match = Curry._1(g, /* () */0);
    if (match !== undefined) {
      if (!first) {
        $$Buffer.add_string(b, sep);
      }
      $$Buffer.add_string(b, match);
      _param = /* () */0;
      _first = false;
      continue ;
    } else {
      return b;
    }
  };
}

function concat_gen(sep, g) {
  return $$Buffer.contents(concat_gen_buf(sep, g));
}

function unlines(l) {
  var len = List.fold_left((function (n, s) {
          return (n + 1 | 0) + s.length | 0;
        }), 0, l);
  var buf = Caml_bytes.caml_create_bytes(len);
  var _i = 0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var i = _i;
    if (l$1) {
      var s = l$1[0];
      var len_s = s.length;
      Bytes.blit_string(s, 0, buf, i, len_s);
      buf[i + len_s | 0] = /* "\n" */10;
      _l = l$1[1];
      _i = (i + len_s | 0) + 1 | 0;
      continue ;
    } else {
      if (i !== len) {
        throw [
              Caml_builtin_exceptions.assert_failure,
              /* tuple */[
                "CCString.ml",
                895,
                6
              ]
            ];
      }
      return Bytes.to_string(buf);
    }
  };
}

function unlines_gen(g) {
  var buf = concat_gen_buf("\n", g);
  $$Buffer.add_char(buf, /* "\n" */10);
  return $$Buffer.contents(buf);
}

function set(s, i, c) {
  if (i < 0 || i >= s.length) {
    Pervasives.invalid_arg("CCString.set");
  }
  return $$String.init(s.length, (function (j) {
                if (i === j) {
                  return c;
                } else {
                  return Caml_string.get(s, j);
                }
              }));
}

function filter_map(f, s) {
  var buf = $$Buffer.create(s.length);
  $$String.iter((function (c) {
          var match = Curry._1(f, c);
          if (match !== undefined) {
            return $$Buffer.add_char(buf, match);
          } else {
            return /* () */0;
          }
        }), s);
  return $$Buffer.contents(buf);
}

function filter(f, s) {
  var buf = $$Buffer.create(s.length);
  $$String.iter((function (c) {
          if (Curry._1(f, c)) {
            return $$Buffer.add_char(buf, c);
          } else {
            return 0;
          }
        }), s);
  return $$Buffer.contents(buf);
}

function flat_map(sep, f, s) {
  var buf = $$Buffer.create(s.length);
  $$String.iteri((function (i, c) {
          if (sep !== undefined) {
            if (i === 0) {
              
            } else {
              $$Buffer.add_string(buf, sep);
            }
          }
          return $$Buffer.add_string(buf, Curry._1(f, c));
        }), s);
  return $$Buffer.contents(buf);
}

var MyExit = Caml_exceptions.create("CCString.MyExit");

function for_all(p, s) {
  try {
    $$String.iter((function (c) {
            if (Curry._1(p, c)) {
              return 0;
            } else {
              throw MyExit;
            }
          }), s);
    return true;
  }
  catch (exn){
    if (exn === MyExit) {
      return false;
    } else {
      throw exn;
    }
  }
}

function exists(p, s) {
  try {
    $$String.iter((function (c) {
            if (Curry._1(p, c)) {
              throw MyExit;
            } else {
              return 0;
            }
          }), s);
    return false;
  }
  catch (exn){
    if (exn === MyExit) {
      return true;
    } else {
      throw exn;
    }
  }
}

function drop_while(f, s) {
  var i = 0;
  while(i < s.length && Curry._1(f, s.charCodeAt(i))) {
    i = i + 1 | 0;
  };
  if (i > 0) {
    return $$String.sub(s, i, s.length - i | 0);
  } else {
    return s;
  }
}

function rdrop_while(f, s) {
  var i = s.length - 1 | 0;
  while(i >= 0 && Curry._1(f, s.charCodeAt(i))) {
    i = i - 1 | 0;
  };
  if (i < (s.length - 1 | 0)) {
    return $$String.sub(s, 0, i + 1 | 0);
  } else {
    return s;
  }
}

function is_space_(param) {
  var switcher = param - 9 | 0;
  if (switcher > 4 || switcher < 0) {
    return switcher === 23;
  } else {
    return switcher !== 2;
  }
}

function ltrim(s) {
  return drop_while(is_space_, s);
}

function rtrim(s) {
  return rdrop_while(is_space_, s);
}

function map2(f, s1, s2) {
  if (s1.length !== s2.length) {
    Pervasives.invalid_arg("CCString.map2");
  }
  return $$String.init(s1.length, (function (i) {
                return Curry._2(f, Caml_string.get(s1, i), Caml_string.get(s2, i));
              }));
}

function iter2(f, s1, s2) {
  if (s1.length !== s2.length) {
    Pervasives.invalid_arg("CCString.iter2");
  }
  for(var i = 0 ,i_finish = s1.length - 1 | 0; i <= i_finish; ++i){
    Curry._2(f, Caml_string.get(s1, i), Caml_string.get(s2, i));
  }
  return /* () */0;
}

function iteri2(f, s1, s2) {
  if (s1.length !== s2.length) {
    Pervasives.invalid_arg("CCString.iteri2");
  }
  for(var i = 0 ,i_finish = s1.length - 1 | 0; i <= i_finish; ++i){
    Curry._3(f, i, Caml_string.get(s1, i), Caml_string.get(s2, i));
  }
  return /* () */0;
}

function fold2(f, acc, s1, s2) {
  if (s1.length !== s2.length) {
    Pervasives.invalid_arg("CCString.fold2");
  }
  var _acc = acc;
  var s1$1 = s1;
  var s2$1 = s2;
  var _i = 0;
  while(true) {
    var i = _i;
    var acc$1 = _acc;
    if (i === s1$1.length) {
      return acc$1;
    } else {
      _i = i + 1 | 0;
      _acc = Curry._3(f, acc$1, Caml_string.get(s1$1, i), Caml_string.get(s2$1, i));
      continue ;
    }
  };
}

function for_all2(p, s1, s2) {
  try {
    iter2((function (c1, c2) {
            if (Curry._2(p, c1, c2)) {
              return 0;
            } else {
              throw MyExit;
            }
          }), s1, s2);
    return true;
  }
  catch (exn){
    if (exn === MyExit) {
      return false;
    } else {
      throw exn;
    }
  }
}

function exists2(p, s1, s2) {
  try {
    iter2((function (c1, c2) {
            if (Curry._2(p, c1, c2)) {
              throw MyExit;
            } else {
              return 0;
            }
          }), s1, s2);
    return false;
  }
  catch (exn){
    if (exn === MyExit) {
      return true;
    } else {
      throw exn;
    }
  }
}

function equal_caseless(s1, s2) {
  if (s1.length === s2.length) {
    return for_all2((function (c1, c2) {
                  return CCChar.equal(CCChar.lowercase_ascii(c1), CCChar.lowercase_ascii(c2));
                }), s1, s2);
  } else {
    return false;
  }
}

function pp_buf(buf, s) {
  $$Buffer.add_char(buf, /* "\"" */34);
  $$Buffer.add_string(buf, s);
  return $$Buffer.add_char(buf, /* "\"" */34);
}

function pp(fmt, s) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Char_literal */Block.__(12, [
                      /* "\"" */34,
                      /* String */Block.__(2, [
                          /* No_padding */0,
                          /* Char_literal */Block.__(12, [
                              /* "\"" */34,
                              /* End_of_format */0
                            ])
                        ])
                    ]),
                  "\"%s\""
                ]), s);
}

function make(s, i, len) {
  if (i < 0 || len < 0 || (i + len | 0) > s.length) {
    Pervasives.invalid_arg("CCString.Sub.make");
  }
  return /* tuple */[
          s,
          i,
          len
        ];
}

function full(s) {
  return /* tuple */[
          s,
          0,
          s.length
        ];
}

function copy(param) {
  return $$String.sub(param[0], param[1], param[2]);
}

function underlying(param) {
  return param[0];
}

function sub(param, i$prime, len$prime) {
  var i = param[1];
  if (((i + i$prime | 0) + len$prime | 0) > (i + param[2] | 0)) {
    Pervasives.invalid_arg("CCString.Sub.sub");
  }
  return /* tuple */[
          param[0],
          i + i$prime | 0,
          len$prime
        ];
}

function length$1(param) {
  return param[2];
}

function get(param, j) {
  if (j < 0 || j >= param[2]) {
    Pervasives.invalid_arg("CCString.Sub.get");
  }
  return param[0].charCodeAt(param[1] + j | 0);
}

function blit(param, o1, a2, o2, len) {
  if ((o1 + len | 0) > param[2]) {
    Pervasives.invalid_arg("CCString.Sub.blit");
  }
  return $$String.blit(param[0], param[1] + o1 | 0, a2, o2, len);
}

function fold$1(f, acc, param) {
  var i = param[1];
  var f$1 = f;
  var _acc = acc;
  var s = param[0];
  var _i = i;
  var j = i + param[2] | 0;
  while(true) {
    var i$1 = _i;
    var acc$1 = _acc;
    if (i$1 === j) {
      return acc$1;
    } else {
      _i = i$1 + 1 | 0;
      _acc = Curry._2(f$1, acc$1, Caml_string.get(s, i$1));
      continue ;
    }
  };
}

function to_gen$1(param) {
  return _to_gen(param[0], param[1], param[2]);
}

function to_seq$1(param, k) {
  var i = param[1];
  var s = param[0];
  for(var i$1 = i ,i_finish = (i + param[2] | 0) - 1 | 0; i$1 <= i_finish; ++i$1){
    Curry._1(k, Caml_string.get(s, i$1));
  }
  return /* () */0;
}

function to_klist$1(param) {
  var len = param[2];
  var i = param[1];
  var s = param[0];
  return (function (param) {
      return _to_klist(s, i, len, param);
    });
}

function to_list$1(param) {
  return _to_list(param[0], /* [] */0, param[1], param[2]);
}

function pp_buf$1(buf, param) {
  $$Buffer.add_char(buf, /* "\"" */34);
  $$Buffer.add_substring(buf, param[0], param[1], param[2]);
  return $$Buffer.add_char(buf, /* "\"" */34);
}

function pp$1(fmt, s) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Char_literal */Block.__(12, [
                      /* "\"" */34,
                      /* String */Block.__(2, [
                          /* No_padding */0,
                          /* Char_literal */Block.__(12, [
                              /* "\"" */34,
                              /* End_of_format */0
                            ])
                        ])
                    ]),
                  "\"%s\""
                ]), copy(s));
}

var make$1 = $$String.make;

var copy$1 = $$String.copy;

var sub$1 = $$String.sub;

var fill = $$String.fill;

var concat = $$String.concat;

var trim = $$String.trim;

var escaped = $$String.escaped;

var index = $$String.index;

var index_opt = $$String.index_opt;

var rindex = $$String.rindex;

var rindex_opt = $$String.rindex_opt;

var index_from = $$String.index_from;

var index_from_opt = $$String.index_from_opt;

var rindex_from = $$String.rindex_from;

var rindex_from_opt = $$String.rindex_from_opt;

var contains = $$String.contains;

var contains_from = $$String.contains_from;

var rcontains_from = $$String.rcontains_from;

var uppercase = $$String.uppercase;

var lowercase = $$String.lowercase;

var capitalize = $$String.capitalize;

var uncapitalize = $$String.uncapitalize;

var compare = $$String.compare;

var init = $$String.init;

var iter = $$String.iter;

var iteri = $$String.iteri;

var map = $$String.map;

var mapi = $$String.mapi;

var blit$1 = $$String.blit;

var capitalize_ascii = $$String.capitalize_ascii;

var uncapitalize_ascii = $$String.uncapitalize_ascii;

var uppercase_ascii = $$String.uppercase_ascii;

var lowercase_ascii = $$String.lowercase_ascii;

var Find = {
  compile: compile,
  rcompile: rcompile,
  find: find,
  rfind: rfind
};

var Split = {
  no_drop: no_drop,
  list_: list_,
  gen: gen,
  seq: seq,
  klist: klist,
  list_cpy: list_cpy,
  gen_cpy: gen_cpy,
  seq_cpy: seq_cpy,
  klist_cpy: klist_cpy,
  left: left,
  left_exn: left_exn,
  right: right,
  right_exn: right_exn
};

var Sub = {
  make: make,
  full: full,
  copy: copy,
  underlying: underlying,
  sub: sub,
  get: get,
  length: length$1,
  blit: blit,
  fold: fold$1,
  to_gen: to_gen$1,
  to_seq: to_seq$1,
  to_klist: to_klist$1,
  to_list: to_list$1,
  pp_buf: pp_buf$1,
  pp: pp$1
};

exports.make = make$1;
exports.copy = copy$1;
exports.sub = sub$1;
exports.fill = fill;
exports.concat = concat;
exports.trim = trim;
exports.escaped = escaped;
exports.index = index;
exports.index_opt = index_opt;
exports.rindex = rindex;
exports.rindex_opt = rindex_opt;
exports.index_from = index_from;
exports.index_from_opt = index_from_opt;
exports.rindex_from = rindex_from;
exports.rindex_from_opt = rindex_from_opt;
exports.contains = contains;
exports.contains_from = contains_from;
exports.rcontains_from = rcontains_from;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.uncapitalize = uncapitalize;
exports.equal = equal;
exports.compare = compare;
exports.is_empty = is_empty;
exports.hash = hash;
exports.init = init;
exports.rev = rev;
exports.pad = pad;
exports.of_char = of_char;
exports.of_gen = of_gen;
exports.of_seq = of_seq;
exports.of_klist = of_klist;
exports.of_list = of_list;
exports.of_array = of_array;
exports.to_array = to_array;
exports.find = find$1;
exports.find_all = find_all;
exports.find_all_l = find_all_l;
exports.mem = mem;
exports.rfind = rfind$1;
exports.replace = replace;
exports.is_sub = is_sub;
exports.repeat = repeat;
exports.prefix = prefix;
exports.suffix = suffix;
exports.chop_prefix = chop_prefix;
exports.chop_suffix = chop_suffix;
exports.take = take;
exports.drop = drop;
exports.take_drop = take_drop;
exports.lines = lines;
exports.lines_gen = lines_gen;
exports.concat_gen = concat_gen;
exports.unlines = unlines;
exports.unlines_gen = unlines_gen;
exports.set = set;
exports.iter = iter;
exports.iteri = iteri;
exports.map = map;
exports.mapi = mapi;
exports.filter_map = filter_map;
exports.filter = filter;
exports.flat_map = flat_map;
exports.for_all = for_all;
exports.exists = exists;
exports.length = length;
exports.blit = blit$1;
exports.fold = fold;
exports.to_gen = to_gen;
exports.to_seq = to_seq;
exports.to_klist = to_klist;
exports.to_list = to_list;
exports.pp_buf = pp_buf;
exports.pp = pp;
exports.drop_while = drop_while;
exports.rdrop_while = rdrop_while;
exports.ltrim = ltrim;
exports.rtrim = rtrim;
exports.map2 = map2;
exports.iter2 = iter2;
exports.iteri2 = iteri2;
exports.fold2 = fold2;
exports.for_all2 = for_all2;
exports.exists2 = exists2;
exports.capitalize_ascii = capitalize_ascii;
exports.uncapitalize_ascii = uncapitalize_ascii;
exports.uppercase_ascii = uppercase_ascii;
exports.lowercase_ascii = lowercase_ascii;
exports.equal_caseless = equal_caseless;
exports.Find = Find;
exports.Split = Split;
exports.split_on_char = split_on_char;
exports.split = split;
exports.compare_versions = compare_versions;
exports.compare_natural = compare_natural;
exports.edit_distance = edit_distance;
exports.Sub = Sub;
/* CCChar Not a pure module */
